import classes from "./ThankYouPage.module.scss";
import type { ThankYouPageContentProps } from "./ThankYouPageProps";
import { useTranslation } from "@/hooks/useTranslation";
import { ThankYouPageForm } from "./ThankYouPageForm";
import { useService } from "@/hooks/useService";
import { useDonationFormStore } from "@/stores";

export function ThankYouPageContent(props: ThankYouPageContentProps) {
  const {
    config,
    enableFrontline,
    enableGiftAid,
    translationsParams,
    submissionId,
  } = props;

  const t = useTranslation("thank_you_page");
  const { sendGiftAid, sendSignUpFrontline } = useService();

  const frontlineConfig = config["thank-you-page-frontline"];
  const giftAidConfig = config["thank-you-page-gift-aid"];
  const { isUKTaxPayer } = useDonationFormStore();

  return (
    <div>
      {isUKTaxPayer && (
        <div className={classes.formatter}>
          {t(
            config["thank-you-page-content-gift-aid-notice"].i18n,
            translationsParams,
          )}
        </div>
      )}

      <div className={classes.formatter}>
        {t(config["thank-you-page-footer"].i18n, translationsParams)}
      </div>

      <div className={classes.spacer} />

      <div className={classes.formGroup}>
        {enableFrontline && frontlineConfig.enabled && (
          <ThankYouPageForm
            {...config["thank-you-page-frontline"]}
            translationsParams={translationsParams}
            sendSubmission={() => sendSignUpFrontline(submissionId)}
          />
        )}

        {enableGiftAid && giftAidConfig.enabled && (
          <ThankYouPageForm
            {...config["thank-you-page-gift-aid"]}
            translationsParams={translationsParams}
            sendSubmission={() => sendGiftAid(submissionId)}
          />
        )}
      </div>
    </div>
  );
}
